import {connect} from 'react-redux';
import Press from '../components/press/press';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    defaultOptions: state.store.defaultOptions
  };
};

export default connect(mapStateToProps)(Press);



// WEBPACK FOOTER //
// ./src/containers/press.js